/**
 * 手势与水库交互集中配置
 * 统一管理磁吸、迟滞、稳定门控及时间阈值，杜绝散落 magic numbers。
 */

export const GESTURE_INTERACTION_CONFIG = Object.freeze({
  // 磁吸与迟滞参数 (像素)
  snapRadiusPx: 70,            // 初始吸附半径 (px)
  releaseRadiusPx: 105,        // 脱离吸附迟滞半径 (px)，必须 > snapRadiusPx
  switchMarginPx: 12,          // 目标切换安全裕度 (px)

  // 稳定门控时间 (毫秒)
  targetStableMs: 200,         // 悬停稳定时间，达到后从 NEAR_TARGET 转为 SNAPPED
  smoothingMs: 150,            // 光标平滑插值时长 (ms)

  // 手势识别与锁定门控
  fistConfidenceThreshold: 0.70, // 握拳有效置信度阈值
  fistLockHoldMs: 350,         // 握拳持续稳定时长阈值 (ms)
  fistGraceMs: 120,            // 握拳抖动容错窗口 (ms)
  openPalmReleaseMs: 300,      // 张开手掌释放锁定阈值 (ms)
})

export default GESTURE_INTERACTION_CONFIG
